module.exports = __webpack_public_path__ + "static/disease-a79ad775741c3cf908514b45bf9a06e1.png";